import React , { useEffect, useState } from 'react'
import { Route, Routes , useLocation} from 'react-router-dom'
import Navbar from '../component/Navbar/Main'
import Footer from '../component/Footer/Main'
import Home from '../component/Home/Main'
import AboutUs from '../component/AboutUs/Main'
import Review from '../component/Pages/Review/Main'
import Contact from '../component/Contact/Main'
import Faq from '../component/Pages/Faq/Main'
import SignIn from '../component/Pages/SignIn/Main'
import SignUp from '../component/Pages/SignUp/Main'
import Pricing from '../component/Pricing/Main'
import Blog from '../component/Blog/Blog/Main'
import BlogSingle from '../component/Blog/BlogSingle/Main'
const Routing = () => {

    const location = useLocation();



    const [footerpage, setfooterpage] = useState(false)
    useEffect(() => {
      if (location.pathname === "/sign-in" || location.pathname === "/sign-up" ){
        setfooterpage(false)
      }else{
        setfooterpage(true)
      }
    }, [location])


    const [footer , setfooter] = useState({f5 : true})
    const [navbar , setnavbar] = useState({n4 : true})
    const [brdcum , setbrdcum] = useState({b1 : true})
    
    return (
        <>
            <Navbar navbar = {navbar}/>
            <Routes>
                <Route path="/" element={<Home setfooter = {setfooter} setnavbar = {setnavbar} setbrdcum = {setbrdcum}/>} />
                <Route path="/about" element={< AboutUs setnavbar = {setnavbar} brdcum = {brdcum}/>} />
                <Route path="/review" element={< Review setnavbar = {setnavbar} brdcum = {brdcum} />} />
                <Route path="/contact" element={< Contact brdcum = {brdcum}/>} />
                <Route path="/faq" element={< Faq brdcum = {brdcum} />} />
                <Route path="/sign-in" element={< SignIn />} />
                <Route path="/sign-up" element={< SignUp />} />
                <Route path="/pricing" element={< Pricing brdcum = {brdcum}/>} />
                <Route path="/blog" element={< Blog brdcum = {brdcum}/>} />
                <Route path="/blog-single" element={< BlogSingle brdcum = {brdcum}/>} />

            </Routes>
            {footerpage && <Footer footer = {footer}/>}
        </>
    )
}

export default Routing